import gql from 'graphql-tag';

const UPDATE_ENTERPRISE_MUTATION = gql`
  mutation(
      $customerId: Int!,
      $enterpriseId: Int!,
      $startDate: Date!) {  
    updateCustomerEnterprise(
      customerId: $customerId,
      enterpriseId: $enterpriseId,
      startDate: $startDate,
    ){
      startDate
    }
  }
`;

export default UPDATE_ENTERPRISE_MUTATION;
